import {
    AdDefinition,
    createRegisterableComponent,
} from '@news-mono/web-common'
import React from 'react'
import {
    AdUnitWrapper,
    AdUnitWrapperProps,
} from '../../advertising/AdUnit/AdUnitWrapper'

export type AdUnitRouteProps = Omit<AdUnitWrapperProps, 'onEvent'> & {
    slot: AdDefinition
}

export const AdUnitRegistration = createRegisterableComponent(
    'ad-unit',
    (props: AdUnitRouteProps, services) => {
        return (
            <AdUnitWrapper
                adState={services.adState}
                unitId={props.slot.id}
                onEvent={services.onEvent}
                breakout={props.breakout}
                hiddenUntilLoaded={props.hiddenUntilLoaded}
                noticePosition={props.noticePosition}
                padding={props.padding}
                stickyOffset={props.stickyOffset}
                unitRendered={props.unitRendered}
                preventCollapse={props.preventCollapse}
            />
        )
    },
)
